var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolTipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0.833374C2.99067 0.833374 0 3.82404 0 7.50004C0 11.176 2.99067 14.1667 6.66667 14.1667C10.3427 14.1667 13.3333 11.176 13.3333 7.50004C13.3333 3.82404 10.3427 0.833374 6.66667 0.833374ZM7.16667 10.6667C7.16667 10.9427 6.94267 11.1667 6.66667 11.1667C6.39067 11.1667 6.16667 10.9427 6.16667 10.6667V7.00004C6.16667 6.72404 6.39067 6.50004 6.66667 6.50004C6.94267 6.50004 7.16667 6.72404 7.16667 7.00004V10.6667ZM6.66667 5.50004C6.29833 5.50004 6 5.20171 6 4.83337C6 4.46504 6.29833 4.16671 6.66667 4.16671C7.035 4.16671 7.33333 4.46504 7.33333 4.83337C7.33333 5.20171 7.035 5.50004 6.66667 5.50004Z",
    fill: "#DE9C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTipIcon);
export default __webpack_public_path__ + "static/media/ToolTipIcon.520fda06ab143aa70d973456f0ff113d.svg";
export { ForwardRef as ReactComponent };